var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoTabela01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2600",
    transform: "translate(-948.558 -530.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1413_1_",
    d: "M949.1,549.1H984v2.3h-34.9V549.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1435_1_",
    d: "M949.1,560.1H984v2.3h-34.9V560.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1414_1_",
    d: "M949.1,545.5H984v2.3h-34.9V545.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1436",
    d: "M949.1,556.4H984v2.3h-34.9V556.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1415_1_",
    d: "M949.1,541.8H984v2.3h-34.9V541.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1437",
    d: "M949.1,552.8H984v2.3h-34.9V552.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1417_1_",
    d: "M949.1,538.2H984v2.3h-34.9V538.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1418_1_",
    d: "M949.1,534.5H984v2.3h-34.9V534.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTabela01);
export default __webpack_public_path__ + "static/media/ico-tabela-01.1236d0087f62da35eef778435196aa5f.svg";
export { ForwardRef as ReactComponent };